import React from 'react'

export default function IconsCalendarCheck({ color = '#C8C5FE', className = 'icons-icon', style = {} }) {
    return (
        <svg
            className={className}
            style={style}
            width='17'
            height='19'
            viewBox='0 0 17 19'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M4.91663 0.75V4.08333M11.5833 0.75V4.08333'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M14.0833 2.41675H2.41667C1.49619 2.41675 0.75 3.16294 0.75 4.08341V15.7501C0.75 16.6706 1.49619 17.4167 2.41667 17.4167H14.0833C15.0038 17.4167 15.75 16.6706 15.75 15.7501V4.08341C15.75 3.16294 15.0038 2.41675 14.0833 2.41675Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M0.75 7.41675H15.75M5.75 12.4167L7.41667 14.0834L10.75 10.7501'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
